import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import { useQuery } from 'react-query';
import { Col, Row } from '../../VuexyDesign/atoms/_index';
import ListTrendingPosts from './ListTrendingPosts';
import {
  CommunityPostInfo,
  getCommunityReleatedPostData,
  getPostInfoDataBySlug,
} from '../../api/lib/api/musicKnowledgeHub';
import Loader from '../common/Loader';
import NotFound from '../../pages/_error';
import { RootState, musicKnowledgeHubActions, useDispatch } from '../../api';
import {
  setBlogPostInfoData,
  setTotalCommentsCountForPost,
} from '../../api/redux/dispatch/musicKnowledgeHub';
import BlogPostMusicKnowledgeHub from '../../containers/MusicKnowledgeHub/BlogPostMusicKnowledgeHub';
import JoinOurDemoCard from './JoinOurDemoCard';
import RenderStructuredData from '../../utils/renderStructuredData';
import getPlainTextFromHtml from '../../utils/getPlainTextFromHtml';

const PostBySlug = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const getPostData = useSelector(
    (state: RootState) => state?.musicKnowledgeHub.blogPostInfoData,
  );
  const [postCommunitySlug, setPostCommunitySlug] = useState<string>();
  const slug = router.query.slug as string;
  const {
    data: postInfo,
    isError,
    isFetching,
    refetch,
  } = useQuery<CommunityPostInfo>(['community-info-data', slug], () =>
    getPostInfoDataBySlug(slug),
  );

  const requestForTrendingPosts = useQuery(
    ['trending-posts', postCommunitySlug],
    () => {
      if (postCommunitySlug) {
        return getCommunityReleatedPostData(
          postCommunitySlug,
          1,
          5,
          'Trending',
        );
      }
      return null;
    },
  );

  useEffect(() => {
    if (postInfo) {
      setPostCommunitySlug(postInfo.community.slug);
      dispatch(musicKnowledgeHubActions.fetchCommentsData(postInfo.id));
      dispatch(setBlogPostInfoData(postInfo));
      dispatch(setTotalCommentsCountForPost(postInfo.total_comments));
      refetch();
    }
  }, [postInfo]);

  if (isFetching) {
    return (
      <div className="d-flex justify-content-center">
        <Loader />
      </div>
    );
  }
  if (!postInfo || isError) {
    return <NotFound />;
  }
  return (
    <>
      {getPostData && getPostData.id !== 0 ? (
        <>
          <RenderStructuredData
            data={{
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: [
                {
                  '@type': 'Question',
                  name: getPostData.title,
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: getPlainTextFromHtml(getPostData.body),
                  },
                },
              ],
            }}
          />
        </>
      ) : (
        <></>
      )}

      <div className="mt-5">
        <Row>
          <Col xs={12} md={8}>
            {getPostData && getPostData.id !== 0 ? (
              <>
                <BlogPostMusicKnowledgeHub postInfoData={getPostData} />
              </>
            ) : (
              <></>
            )}
          </Col>
          <Col xs={12} md={4}>
            <JoinOurDemoCard />
            <ListTrendingPosts
              trendingPostsList={requestForTrendingPosts.data?.data}
              isFetching={requestForTrendingPosts.isFetching}
              isError={requestForTrendingPosts.isError}
            />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default PostBySlug;
